import { useCallback } from "react";

import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { SearchSimilarPartsDto } from "#modules/similarPart/infra/searchSimilarParts.api";
import { EmbeddingErrorCheck } from "#modules/similarPart/view/errors/EmbeddingErrorCheck";
import { SearchingStatusCheck } from "#modules/similarPart/view/errors/SearchingStatusCheck";
import { SimilarPartsErrorCheck } from "#modules/similarPart/view/errors/SimilarPartsErrorCheck";
import { useCheckPart } from "#modules/similarPart/view/useCheckPart";
import { Group } from "#shared/view/components/Group";

import { ResultPartCard } from "./ResultPartCard";
import { SearchResult } from "./SearchResult";

type Props = {
  similarParts: SearchSimilarPartsDto | null | undefined;
  part: PartDto;
  isSearching: boolean;
  isFetching: boolean;
  setPart: React.Dispatch<React.SetStateAction<PartDto | null>>;
  displayFeatures: boolean;
  displayScore: boolean;
};

export const ResultContent = ({
  similarParts,
  part,
  isSearching,
  isFetching,
  setPart,
  displayFeatures,
  displayScore,
}: Props) => {
  const { checkPart } = useCheckPart({ onSuccess: (p) => setPart(p) });

  const Card = useCallback(
    (props: Parameters<typeof ResultPartCard>[0]) => (
      <ResultPartCard
        {...props}
        featuresDisplayMode={displayFeatures ? "truncate" : "none"}
        displayScore={displayScore}
      />
    ),
    [displayFeatures, displayScore],
  );

  return (
    <EmbeddingErrorCheck part={part} checkPart={checkPart}>
      <SearchingStatusCheck isSearching={isSearching}>
        <SimilarPartsErrorCheck similarParts={similarParts ?? null}>
          <SearchResult columnCount={5} similarParts={similarParts} sourcePart={part} Card={Card}>
            <Group justify="flex-end">
              <SearchResult.MoreButton isFetching={isFetching} />
            </Group>
          </SearchResult>
        </SimilarPartsErrorCheck>
      </SearchingStatusCheck>
    </EmbeddingErrorCheck>
  );
};
